/* src/app/components/Expand/styles.js */

export default theme => ({
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  expandText: {
    marginLeft: theme.spacing.unit * 1.5,
  },
});



// WEBPACK FOOTER //
// ./src/app/components/Expand/styles.js